import jQuery from 'jquery';

jQuery( document ).ready( function( $ ) {
	$( '#wc_bookings_google_calendar_redirect' ).removeAttr( 'value' );
	$( '.wc-bookings-calendar-connect' ).on( 'click', function() {
		$( '#wc_bookings_google_calendar_redirect' ).val( '1' );
		$( '#bookings_settings' ).trigger( 'submit' );
	} );
} );
